<template>
    <div style="min-height: calc(100vh - 120px); width: 100%; height: 100%; flex-grow: 1; display: flex; justify-content: center; align-items: center;">
        <div style="text-align: center">
            <v-progress-circular
                :size="60"
                :width="6"
                color="grey lighten-1"
                indeterminate
            ></v-progress-circular>
            <br/><br/>
            <span style="text-transform: uppercase" class="grey--text text--lighten-1">
                <slot>{{ text }}</slot>
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            text: {
                type: String,
                default: function() {
                    return this.$t('core.loading_data');
                }
            }
        },
    };
</script>
